import fetch from './index';

// ------------------ HELPMANUAL 帮助问题
// 分页获取问题信息
const getHelpManual = (params: Object) => fetch.axios_admin.get('/helpManual', { params });

// 创建帮助问题
const addHelpManual = (data: any) => fetch.axios_admin.post('/helpManual', data);

// 修改帮助问题
const editHelpManual = (data: FormData) => fetch.axios_admin.put('/helpManual', data);

// 删除帮助问题
const removeManual = (id: string) => fetch.axios_admin.remove(`/helpManual/${id}`);

// 根据分类获取问题
const getMualByType = () => fetch.axios_admin.get('/helpManualCascadeAll');

// 获取所有问题
const getAllMual = (title: string) => fetch.axios_admin.get(`/helpManualAll?title=${title}`);

// 获取具体问题
const getMualById = (id: string) => fetch.axios_admin.get(`/oneHelpManual/?pid=${id}`);

export default {
  getHelpManual,
  addHelpManual,
  editHelpManual,
  removeManual,
  getMualByType,
  getAllMual,
  getMualById,
};
